import React from 'react';
import ReactDOM from 'react-dom';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import * as ReactBootstrap from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import MDIFont from '@mdi/font/css/materialdesignicons.min.css';
import _ from 'lodash';
import * as Bootstrap from 'bootstrap';
import NProgress from 'nprogress';
import Croppie from 'croppie';
import Cropper from 'cropperjs';
import SignaturePad from 'signature_pad/dist/signature_pad.umd.js';
import Promise from 'es6-promise';
import moment from 'moment-timezone';
import propertiesPanelModule from 'bpmn-js-properties-panel';
import { hexToCSSFilter } from 'hex-to-css-filter';
import intlTelInput from 'intl-tel-input';

// External imports.
import '@progress/kendo-ui/css/web/kendo.common-material.less';
import '@progress/kendo-ui/css/web/kendo.material.less';
import '@progress/kendo-ui/css/web/kendo.metro.mobile.less';
import 'nprogress/nprogress.css';
import 'croppie/croppie.css';
import 'cropperjs/dist/cropper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs/css/dataTables.bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'jssocials/dist/jssocials.css';
import 'jssocials/dist/jssocials-theme-classic.css';
import 'awesome-rating/dist/awesomeRating.css';
import 'bpmn-js-properties-panel/styles/properties.less';
import 'bpmn-js-properties-panel/styles/header.less';
import 'datatables.net-responsive-dt/css/responsive.dataTables.min.css';
import 'intl-tel-input/build/css/intlTelInput.css';

// Internal imports.
import './../../static/Themes/Default/Main/default.css';
import './../../resources/style/common.css';
import './../../resources/style/Components/Survey/Style.css';

// SDK libraries.
import Instance from './common/js-subscribe-sdk/lib/Instance';
import EntityManager from './common/js-subscribe-sdk/lib/EntityManager';
import User from './common/js-subscribe-sdk/lib/User';
import ApiClient from './common/js-subscribe-sdk/lib/Api/Client';
import propertiesProviderModule from './common/bpmn-properties-provider';

require('nprogress/nprogress.js');
require('@progress/kendo-ui/js/kendo.all.js');
require('jssocials/dist/jssocials.js');
require('awesome-rating/dist/awesomeRating.js');
require('datatables.net/js/jquery.dataTables.min.js');
require('datatables.net-bs/js/dataTables.bootstrap.min.js');
require('datatables.net-responsive/js/dataTables.responsive.min.js');

const subscribeModdleDescriptor = require('./common/bpmn-properties-provider/descriptors/subscribe.json');

const getEntityManager = (parameters) => {
  return new EntityManager(
    new ApiClient(
      {
        accessToken: parameters.apiToken,
        instanceCode: parameters.instanceCode,
        securityGroup: parameters.securityGroup
      },
      parameters.apiUrl
    )
  );
};

const getInstance = (parameters) => {
  return new Instance(parameters.instanceCode, getEntityManager(parameters), new User(parameters));
};

module.exports = {
  _,
  React,
  ReactDOM,
  Redux,
  ReactRedux,
  Promise,
  PropTypes,
  ReactBootstrap,
  Bootstrap,
  FontAwesome,
  MDIFont,
  NProgress,
  Croppie,
  Cropper,
  getInstance,
  getEntityManager,
  SignaturePad,
  moment,
  propertiesPanelModule,
  hexToCSSFilter,
  propertiesProviderModule,
  subscribeModdleDescriptor,
  intlTelInput,
  deps: [
    '_',
    'React',
    'ReactDOM',
    'Redux',
    'ReactRedux',
    'Promise',
    'PropTypes',
    'Bootstrap',
    'ReactBootstrap',
    'Bootstrap',
    'FontAwesome',
    'NProgress',
    'Croppie',
    'Cropper',
    'getInstance',
    'getEntityManager',
    'SignaturePad',
    'moment',
    'propertiesPanelModule',
    'hexToCSSFilter',
    'propertiesProviderModule',
    'subscribeModdleDescriptor',
    'intlTelInput'
  ]
};



// WEBPACK FOOTER //
// ./src/client/vendor.js